import "core-js/modules/es.array.concat.js";
import styled from 'styled-components';
import { getFontSize } from '@finect/tabular-utils/getFont';
export var FeaturedInner = styled.div.withConfig({
  displayName: "Featured__FeaturedInner",
  componentId: "sc-1ougeid-0"
})(["display:flex;flex-flow:column;"]);
export var FeaturedLabel = styled.span.withConfig({
  displayName: "Featured__FeaturedLabel",
  componentId: "sc-1ougeid-1"
})(["display:inline-block;position:relative;top:2px;visibility:", ";padding:2px 18px;border-radius:", ";box-shadow:", ";margin-left:", ";margin-right:", ";background:", ";font-size:", "rem;line-height:24px;white-space:nowrap;color:#fff;text-align:center;user-select:none;"], function (_ref) {
  var featuring = _ref.featuring;
  return featuring === 'sponsored' || featuring === 'winning' ? 'visible' : 'hidden';
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0 0");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow;
}, function (_ref4) {
  var featuring = _ref4.featuring;
  return featuring === 'advised' ? 'auto' : '0';
}, function (_ref5) {
  var featuring = _ref5.featuring;
  return featuring === 'advised' ? '14px' : 'auto';
}, function (_ref6) {
  var theme = _ref6.theme,
    featuring = _ref6.featuring;
  return featuring === 'sponsored' ? theme.colors.primary : theme.colors.secondary;
}, getFontSize(-1, 'compact'));